// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_1sR1R","content":"index_content_3Xwy9","item":"index_item_3CdU9","item1":"index_item1_1KJTK","item2":"index_item2_P4fxQ"};